/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// @mui icons
import { Dashboard, Notifications, Settings, Undo } from "@mui/icons-material";

// Material Dashboard 2 React layouts
import Dashboard1 from "layouts/studentLayouts/dashboard";
import Notifications1 from "layouts/studentLayouts/notifications";
import PreviousProjects from "layouts/studentLayouts/previousProjects";

const StudentRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Dashboard />,
    route: "/dashboard",
    component: <Dashboard1 />,
  },
  {
    type: "collapse",
    name: "Previous Projects",
    key: "tables",
    icon: <Undo />,
    route: "/tables",
    component: <PreviousProjects />,
  },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Notifications />,
  //   route: "/notifications",
  //   component: <Notifications1 />,
  // },
  // {
  //   type: "collapse",
  //   name: "Settings",
  //   key: "profile",
  //   icon: <Settings />,
  //   route: "/profile",
  //   // component: <Profile1 />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/sign-in",
  //   component: <SignIn />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default StudentRoutes;
